import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { claimOnboardingDayPass, getProfile } from '../../redux/actions/myAccountAction'
import { STORIES } from 'routes/routeConstant'
import { hapticSuccess } from 'utils/haptics'
import ClaimLanding from './ClaimLanding'

/**
 * /claim/trial — one-click link from the re-engagement emails. Claims the
 * no-card onboarding day pass (5 free Standard days) and lands on /stories.
 * Every outcome ends on /stories: on success the refreshed profile makes the
 * stories page reflect the new plan (and the standard free-trial notification
 * takes over); already_used / not_on_free_plan redirect silently.
 */
const ClaimTrial: React.FC = () => {
  const { t } = useTranslation('offers')
  const navigate = useNavigate()
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return // guard the StrictMode double-mount — the claim is one-shot
    hasRun.current = true
    ;(async () => {
      try {
        const res: any = await claimOnboardingDayPass()
        if (res?.granted) {
          hapticSuccess()
          // Refresh the profile so /stories shows the granted Standard access
          // instead of stale Free state.
          await getProfile().catch(() => null)
        }
      } catch (e) {
        // Never trap the user on a blank claim page — /stories either way.
      }
      navigate(STORIES, { replace: true })
    })()
  }, [])

  return <ClaimLanding message={t('claim.activatingDays')} />
}

export default ClaimTrial
